import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: 300,
    minWidth: '500px',
    gap: theme.other.spacing._16,

    [theme.fn.smallerThan('sm')]: {
      minWidth: '100%',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    marginBottom: theme.other.spacing._8,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },
  promoCardContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 400,
  },
  balanceContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 400,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    border: `1px solid ${theme.colors.gray2[1]}`,
    padding: `0 ${theme.other.spacing._16}px`,
  },
}));
